import { lazyWithRetry } from "utils";

export const PatientRecords = lazyWithRetry(() => import("./containers"));